import { CommonActionTypes } from "../../action-types";

const naicsCodes = JSON.parse(localStorage.getItem("naicsCodes"));

const initialState = {
  naicsCodes: naicsCodes ? naicsCodes : null,
};

export default function allNaicsCodesReducer(state = initialState, action) {
  switch (action.type) {
    case CommonActionTypes.GET_ALL_NAICS_CODES_DATA:
      return {
        naicsCodes: action.payload,
      };
    default:
      return state;
  }
}
